import {
    BANK_ADDRESS,
    BANK_BIK,
    BANK_CORR_ACC,
    BANK_INN_KPP,
    BANK_OGRN,
    BANK_PHONE
} from "../../../constants";
import { formatPhoneNumber } from "../../../utils/formatPhoneNumber";

export default {
    seo: {
      title: 'Реквизиты | Банк 131',
      description: 'Реквизиты АО «Банк 131»'
    },
    title: 'Реквизиты',
    content: {
            rectangle: [
                {
                    title: 'ПОЛНОЕ НАИМЕНОВАНИЕ НА РУССКОМ ЯЗЫКЕ',
                    description: 'Акционерное общество «Банк 131»'
                },
                {
                    title: 'СОКРАЩЕННОЕ НАИМЕНОВАНИЕ НА РУССКОМ ЯЗЫКЕ',
                    description: 'АО «Банк 131»'
                },
                {
                    title: 'ПОЛНОЕ НАИМЕНОВАНИЕ НА АНГЛИЙСКОМ ЯЗЫКЕ',
                    description: 'Bank 131 Joint Stock Company'
                },
                {
                    title: 'СОКРАЩЕННОЕ НАИМЕНОВАНИЕ НА АНГЛИЙСКОМ ЯЗЫКЕ',
                    description: 'Bank 131 JSC'
                },
                {
                    title: 'ЮРИДИЧЕСКИЙ АДРЕС',
                    description: BANK_ADDRESS
                },
                {
                    title: 'ПОЧТОВЫЙ АДРЕС',
                    description: BANK_ADDRESS
                },
                {
                    title: 'ФАКТИЧЕСКИЙ АДРЕС',
                    description: BANK_ADDRESS
                },
                {
                    title: 'РЕГИСТРАЦИОННЫЙ НОМЕР',
                    description: '3538'
                },
                {
                    title: 'ЛИЦЕНЗИЯ',
                    description: 'Базовая лицензия на осуществление банковских операций со средствами в рублях и иностранной валюте (с правом привлечения во вклады денежных средств физических лиц) и на осуществление банковских операций с драгоценными металлами № 3538 от 29.11.2024.'
                },
                {
                    title: 'УСТАВНЫЙ КАПИТАЛ БАНКА',
                    description: '340 000 000 рублей'
                },
                {
                    title: 'УЧАСТИЕ В СИСТЕМЕ ОБЯЗАТЕЛЬНОГО СТРАХОВАНИЕ ВКЛАДОВ',
                    description: 'Да'
                },
                {
                    title: 'ИНН / КПП',
                    description: BANK_INN_KPP
                },
                {
                    title: 'ОГРН',
                    description: BANK_OGRN
                },
                {
                    title: 'ДАТА ПРИСВОЕНИЯ ОГРН',
                    description: '29 ноября 2024 года'
                },
                {
                    title: 'КОРРЕСПОНДЕНТСКИЙ СЧЕТ',
                    description: `${BANK_CORR_ACC} в Операционно-кассовом центре № 6 Волго-Вятского главного управления Центрального банка Российской Федерации`
                },
                {
                    title: 'БИК БАНКА',
                    description: BANK_BIK
                },
                {
                    title: 'КЛАССИФИКАТОРЫ В СТАТИСТИЧЕСКОМ РЕГИСТРЕ',
                    description: 'ОКПО 58583325 ОКАТО 92401367000 <br/>' +
                        'ОКТМО 92701000001 ОКОГУ 4210014<br/>' +
                        'ОКФС 16 ОКОПФ 12267<br/>' +
                        'ОКВЭД 64.19 Денежное посредничество прочее'
                },
                {
                    title: 'ОФИЦИАЛЬНЫЕ САЙТЫ БАНКА',
                    description: 'www.131.ru'
                },
                {
                    title: 'ЭЛЕКТРОННАЯ ПОЧТА',
                    description: 'help@131.ru'
                },
                {
                    title: 'ТЕЛЕФОН',
                    description: formatPhoneNumber(BANK_PHONE)
                },
                {
                    title: 'РЕЖИМ РАБОТЫ',
                    description: 'Понедельник – пятница: с 09:00 до 18:00 (обед с 13:00 до 14:00, время мск);<br/>' +
                        'Суббота - воскресенье: выходные (нерабочие) дни.'
                },
            ],
            description: 'Вся размещенная на сайте информация представлена только для общего ознакомления и не является публичной офертой.<br/>' +
                '<br/>' +
                'Лицо, ответственное за полноту, достоверность и актуальность публикуемых на Web-сайте сведений: Кропанев Артур, press@131.ru<br/>' +
                '<br/>' +
                'Надзор за деятельностью АО «Банк 131», рег номер 3538: Банковский надзор за деятельностью кредитной организации (АО «Банк 131») осуществляет Служба текущего банковского надзора Банка России.<br/>' +
                '<br/>' +
                'Телефоны Контактного центра Центрального банка Российской Федерации: адрес: 107016, г. Москва, ул. Неглинная, 12, тел. 8-800-250-4072, 8-495-771-9100.<br/>' +
                '<br/>' +
                'Надзор за соблюдением требований законодательства Российской Федерации в сфере защиты прав потребителей финансовых услуг осуществляет Служба по защите прав потребителей и обеспечению доступности финансовых услуг Банка России.<br/>' +
                '<br/>' +
                'Обращение о нарушении действиями (бездействием) кредитной организации законодательства Российской Федерации, а также охраняемых законом прав и интересов физических или юридических лиц может быть направлено для рассмотрения в Банк России через интернет-приемную <br/>' +
                '(www.cbr.ru/Интернет-приемная).<br/>' +
                '<br/>' +
                'Вся размещенная на сайте информация представлена только для общего ознакомления <br/>' +
                'и не является публичной офертой. Та информация, которая на данный момент отсутствует, <br/>' +
                'скоро появится и мы добавим ее на сайт.'
    },
}